import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import "../components/terms-conditions.css"
import Header from "../components/header"
import NotFound from "../pages/404"

function TermsPage() {
  return (
    <Layout>
      <Seo
        title="Términos y condiciones"
        path="/terms-conditions"
        description="Términos de uso, compra y pago del sitio."
      />
      <Header showCollapsed={true} />
      <div className="TermsConditions">
        <h1>TERMINOS Y CONDICIONES</h1>
        <h4>
          Términos que se aplican solo a los usuarios que suscriben nuestros
          Servicios de Pago
        </h4>
        <h3>Servicios de Pago</h3>
        <p>
          1.1 {process.env.GATSBY_platformCompanyName} acepta proporcionarle
          acceso a los Servicios de pago que haya adquirido, tal como se
          establece en el Resumen del Pedido, siempre que continúe pagando y
          sujeto a los términos de este Acuerdo.
          <br />
          <br />
          1.2 En este sentido, el Titular garantiza el cumplimiento de la
          normativa vigente en materia de protección de datos personales,
          reflejada en la Ley de Protección de Datos en México, cuenta con una
          ley que regula el tratamiento de los datos personales por parte de
          empresas del sector privado desde el 5 de julio de 2010, esa ley se
          llama Ley Federal de Protección de Datos Personales en Posesión de los
          Particulares o Ley de Protección de Datos. Están obligadas por la Ley
          de Protección de Datos en México todas las empresas del sector privado
          que obtengan, usen, almacenen y/o transfieran datos personales como
          parte de sus actividades.
          <br />
          <br />
          Para asegurar la continuidad de los servicios provenientes de
          terceros, como el nombre de dominio, el cobro por la renovación del
          plan anual correspondiente al año siguiente será realizado en el mes
          11 del plazo del plan actual. Aun así, tu plan tendrá una duración de
          12 meses. Los Servicios se brindan de manera personalizada para
          cumplir con sus estándares y {
            process.env.GATSBY_platformCompanyName
          }{" "}
          no proporcionará ningún reembolso a menos que los servicios no se
          brinden de acuerdo de acuerdo con este Contrato.
          <br />
          <br />
          1.3 Puedes cancelar o modificar cualquier Servicio al final del
          periodo mínimo o durante cualquier Periodo de Suscripción Adicional
          que esté activo en ese momento antes de su finalización.
          <br />
          <br />
          1.4 Usted puede actualizar al Servicio de Pago en cualquier momento.
          Por favor, póngase en contacto con{" "}
          <span>{process.env.GATSBY_platformEmail}</span> para obtener más
          información.
          <br />
          <br />
          1.5 Los precios de los Servicios de Pago se ajustan en cualquier
          momento después de la expiración de su Término Mínimo con un aviso por
          escrito de 1 mes.
          <br />
          <br />
          1.6 Si usted falla en el pago de la cuota mensual dentro de los 30
          días de su vencimiento o si usted solicita cancelar su cuenta antes
          del vencimiento de su Plazo Mínimo, el monto total a pagar por la
          duración completa del Plazo Mínimo vencerá inmediatamente y podremos
          suspender la prestación de cualquier Servicio de Pago hasta que se
          reciba dicho monto. Se cobrarán intereses sobre los pagos vencidos a
          una tasa anual igual al 8% sobre la tasa base vigente y también se le
          podrán cobrar los gastos de recuperación de deudas y los honorarios
          legales en los que incurramos al cobrar el pago.
          <br />
          <br />
          1.7 La fecha de inicio de los Servicios de Pago será la fecha en que
          usted realizó su pedido. Si usted no ha proporcionado a{" "}
          {process.env.GATSBY_platformCompanyName} toda la información necesaria
          para comenzar a configurar el dominio y la pagina; Los servicios de
          Pago deben ser dentro de los 7 días previos a la Fecha de Inicio, es
          posible que algunos o todos los servicios no estén disponibles a
          partir de la Fecha de Inicio, pero usted seguirá siendo responsable de
          continuar con la actualización de la información y de pagar a partir
          de esa fecha.
          <br />
          <br />
          1.8 Las facturas están disponibles a pedido por correo{" "}
          <span>{process.env.GATSBY_platformEmail}</span>.
        </p>
        <h4>Términos que se aplican a todos los usuarios</h4>
        <h3>Licencia</h3>
        <p>
          2.1 Usted otorga a {process.env.GATSBY_platformCompanyName} y a sus
          afiliados un derecho no exclusivo, mundial, transferible y
          sublicenciable para usar, copiar, modificar, distribuir, publicar y
          procesar cualquier contenido que cargue en la Plataforma y, si
          corresponde, cualquier otro contenido relacionado a su negocio en la
          Plataforma.
          <br />
          <br />
          2.2 Puede finalizar esta licencia para contenido específico eliminando
          dicho contenido de la Plataforma o, más concretamente, rescindiendo
          este Acuerdo.
          <br />
          <br />
          2.3 Si paga por Servicios de pago, también otorga a{" "}
          {process.env.GATSBY_platformCompanyName} una licencia para administrar
          sus otras cuentas digitales con el fin de promocionar su empresa.
          Dicha licencia continuará después de la terminación de este Acuerdo
          hasta que haya asumido la propiedad de dichas cuentas o éstas hayan
          sido eliminadas por {process.env.GATSBY_platformCompanyName} de
          conformidad con la cláusula.
          <br />
          <br />
          2.4 Usted confirma que cumplirá con los términos de uso de todas las
          otras cuentas digitales que administramos para usted como parte de los
          servicios de pago. Usted reconoce que, cuando gestionamos sus otras
          cuentas digitales, el contenido publicado en dichas plataformas es
          gestionado por terceros y puede estar fuera del control de{" "}
          {process.env.GATSBY_platformCompanyName}
          <br />
          <br />
          2.5 Si paga por Servicios de pago,{" "}
          {process.env.GATSBY_platformCompanyName} puede otorgarle una licencia
          de una página web de empresa y / o un nombre de dominio.{" "}
          {process.env.GATSBY_platformCompanyName} es el que registra el Nombre
          de Dominio.
          <br />
          <br />
          2.6 {process.env.GATSBY_platformCompanyName} posee todos los Derechos
          de propiedad intelectual en la Plataforma{" "}
          {process.env.GATSBY_platformCompanyName} y en los Servicios de pago.
          Salvo que se indique expresamente, este acuerdo no le concede a usted
          ningún derecho de propiedad intelectual con respecto a la Plataforma{" "}
          {process.env.GATSBY_platformCompanyName} y los Servicios de pago.
        </p>

        <h3>Garantias</h3>
        <p>
          3.1 Usted garantiza a {process.env.GATSBY_platformCompanyName} lo
          siguiente:
          <br />
          <br />
          <li>
            3.1.1 Tiene al menos 18 años de edad y puede celebrar este Acuerdo;
          </li>
          <br />
          <li>
            3.1.2 No intentará eludir la seguridad, realizar ingeniería inversa
            o interferir con el correcto funcionamiento de la plataforma{" "}
            {process.env.GATSBY_platformCompanyName} u otras cuentas digitales;
          </li>
          <br />
          <li>
            3.1.3 Mantendrá segura cualquier contraseña para acceder a la
            plataforma {process.env.GATSBY_platformCompanyName} o cualquier otra
            relacionada y será responsable de cualquier acceso no autorizado
            como resultado de que un tercero obtenga su contraseña;
          </li>{" "}
          <br />
          <li>
            3.1.4 Cualquier contenido que cargue a{" "}
            {process.env.GATSBY_platformCompanyName} o{" "}
            {process.env.GATSBY_cmsSystem} y su uso de cualquier Nombre de
            Dominio no será difamatorio, indecente o ilegal o infringirá los
            Derechos de Propiedad Intelectual de un tercero y debe ser preciso y
            actualizado;
          </li>
          <br />
          <li>
            3.1.5 No usará la Plataforma que le proporciona{" "}
            {process.env.GATSBY_platformCompanyName} para fines comerciales si
            no es en relación con algún Servicio de pago que haya adquirido;
          </li>
          <br />
          <li>
            3.1.6 Garantizará que todos los datos de usuario puestos a su
            disposición desde el sitio web de su empresa se almacenen y
            administren de acuerdo con todas las leyes de protección de datos
            aplicables y nuestra Política de privacidad.
          </li>
          <br />
        </p>
      </div>
    </Layout>
  )
}

export default process.env.GATSBY_isMainPlatform === "true"
  ? TermsPage
  : NotFound
